import moment from 'moment'

/**
 *
 * General structure
 *
 * @class Model
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/model/Model.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default class Model {
  buildModel(modelData){
    for (let property in this){
      if (Object.prototype.hasOwnProperty.call(this, property)){
        if (Object.prototype.hasOwnProperty.call(modelData, property)){
          if (this[property] === null){
            this[property] = modelData[property]
          }
          else if (typeof this[property] === 'function')
            this[property] = this[property](modelData[property], property)
          else
            throw new Error(`Unhandled property initialisation for '${property}'`)
        }else{
          this[property] = undefined;
        }
      }
    }
  }

  checkProps(...props) {
    if (props)
      props.forEach(prop => {
        const propChain = prop.split('.')
        let currentObj = this

        for (let i=0; i<propChain.length; i++){
          if (!Object.prototype.hasOwnProperty.call(currentObj, propChain[i]) || currentObj[propChain[i]] === undefined)
            throw new Error(`The model '${this.constructor.name}' did not receive data for property: '${propChain.slice(0, i+1).join('.')}'`)

          currentObj = currentObj[propChain[i]]
          if (!currentObj) return
          if (Array.isArray(currentObj)){
            if (!currentObj.length) return
            currentObj = currentObj[0]
          }
        }
      })
  }
}

export function toProp() {
  return null
}

export function toMoment() {
  return function (data) {
    return data === null ? null : moment(data)
  }
}

export function toModel(constructor) {
  return function (data) {
    return data === null ? null : new constructor(data)
  }
}

export function toModels(constructor) {
  return function (data) {
    if (data && Array.isArray(data))
      return data.map((instance) => instance === null ? null : new constructor(instance))
    else
      return data
  }
}